import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';
import type { WebRequestConsoleStores } from '../stores';
import { STORE_WEB_REQUEST_CONSOLE } from '../stores/constants';
import WebRequestConsolePanel from '../components/WebRequestConsolePanel';

const WebRequestConsolePage: React.FC<WebRequestConsoleStores> = ({ webRequestConsoleUI: store }) => {
    if (!store) {
        return null;
    }

    return (
        <HasPermission permissionClaim={AppPermissions.CanExecuteWebRequestConsole}>
            <WebRequestConsolePanel store={store} />
        </HasPermission>
    );
};

export default inject(STORE_WEB_REQUEST_CONSOLE)(observer(WebRequestConsolePage));
